import React from "react";
import PageTitle from "../../../components/Accessibility/PageTitle";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Typography } from "@mui/material";
import { sxRefundButton, sxRefundButtonText } from "../Reembolso/sxProps";
import { useNavigate } from "react-router-dom";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import "./styles.css";

const OutrasSolicitacoesFinanceiras = () => {
  const navigate = useNavigate();

  const accessibility = useAccessibility();

  return (
    <div className="email-nfe-container">
      <PageTitle text="Outras Solicitações Financeiras" />
      <div className="refund-buttons-holder">
        <div className="refund-option-button">
          <Button
            fullWidth
            style={{
              ...accessibility.contrastStyle,
              ...accessibility.contrastBorderAccessibility,
            }}
            sx={sxRefundButton}
            onClick={() =>
              navigate("/financeiro/outrasSolicitacoesFinanceiras/novaSolicitacao")
            }
          >
            <Typography
              style={accessibility.textStyleAccessibility}
              sx={sxRefundButtonText}
            >
              Nova solicitação
            </Typography>
            <FontAwesomeIcon
              style={accessibility.textStyleAccessibility}
              color="#383838"
              size="lg"
              icon={faChevronRight}
            />
          </Button>
        </div>
        <div className="refund-option-button">
          <Button
            fullWidth
            style={{
              ...accessibility.contrastStyle,
              ...accessibility.contrastBorderAccessibility,
            }}
            sx={sxRefundButton}
            onClick={() =>
              navigate("/financeiro/outrasSolicitacoesFinanceiras/minhasSolicitacoes")
            }
          >
            <Typography
              style={accessibility.textStyleAccessibility}
              sx={sxRefundButtonText}
            >
              Minhas solicitações
            </Typography>
            <FontAwesomeIcon
              style={accessibility.textStyleAccessibility}
              color="#383838"
              size="lg"
              icon={faChevronRight}
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OutrasSolicitacoesFinanceiras;
